import { differenceInDays } from 'date-fns'
import { parseDateFromISO } from '../parseDateFromISO/parseDateFromISO'

export const getAccountAgeDays = (signupDate: Maybe<string>): Maybe<number> => {
  const parsed = parseDateFromISO(signupDate)

  if (!parsed) {
    return null
  }

  return differenceInDays(new Date(), parsed)
}
